package com.essntl.features.paymentparameter.domain.model

data class PaymentParameterModel(
    val id: String,
    val createdAt: String,
    val name: String?,
    val amount: Int?,
    val method: Method?,
    val type: Type?,
    val qbItemId: String?,
    val isInvoice: Boolean?,
    val applyToAmount: Boolean?,
) {
    enum class Method {
        Add,
        Substract,
    }

    enum class Type {
        FlatFee,
        Percentage,
    }

    fun getChangedFields(other: PaymentParameterModel) =
        PaymentParameterModel(
            id = id,
            createdAt = createdAt,
            name = if (name.orEmpty() != other.name.orEmpty()) other.name else null,
            amount = if (amount != other.amount) other.amount else null,
            method = if (method != other.method) other.method else null,
            type = if (type != other.type) other.type else null,
            qbItemId = if (qbItemId != other.qbItemId) other.qbItemId else null,
            isInvoice = if (isInvoice != other.isInvoice) other.isInvoice else null,
            applyToAmount = if (applyToAmount != other.applyToAmount) other.applyToAmount else null,
        )

    val isEmpty get() = this.copy(id = "", createdAt = "") == empty

    companion object {
        val empty =
            PaymentParameterModel(
                id = "",
                createdAt = "",
                name = null,
                amount = null,
                method = null,
                type = null,
                qbItemId = null,
                isInvoice = null,
                applyToAmount = null,
            )
    }
}